import React from 'react';
import './CaseStudyHead.css';

const CaseStudyHead = ({
  topText = 'Projects',
  bottomText = 'Case Study',
  bgColor = '#570D1B',
  topColor = '#FBECCA',
  bottomColor = '#f9b24d',
  className = '',
  as: HeadingTag = 'h1',
}) => {
  const sectionClassName = ['case-study-head', className].filter(Boolean).join(' ');

  return (
    <section
      className={sectionClassName}
      style={{ backgroundColor: bgColor }}
      aria-label={`${topText} ${bottomText}`}
    >
      <HeadingTag className="case-study-head__title">
        <span
          className="case-study-head__line case-study-head__top"
          style={{ color: topColor }}
        >
          {topText}
        </span>
        <span
          className="case-study-head__line case-study-head__bottom"
          style={{ color: bottomColor }}
        >
          {bottomText}
        </span>
      </HeadingTag>
    </section>
  );
};

export default CaseStudyHead;
